<template>
  <div>
    <div class="banner">
      <img src="../../assets/Medical_banner.png" alt="">
    </div>
    <div class="section_w equipment">
      <div class="container" style="position: relative;z-index: 10">
        <div class="section_title left">
          <p>
            医疗设备方案背景
          </p>
          <aside>
            Medical equipment
          </aside>
        </div>
        <div class="row">
          <div class="col-sm-4">
            <div class="shadow">
              <img src="../../assets/Medical_Program_icon01.png" alt="">
              <h4 class="text_ellipsis">
                药剂医疗设备物联网化
              </h4>
              <p>
                药剂医疗设备物联网化是将个体、器械、机构整合为一个整体，医疗设备物联网化使医疗便捷化，提高诊疗效率。
              </p>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="shadow">
              <img src="../../assets/Medical_Program_icon02.png" alt="">
              <h4>
                安全传递
              </h4>
              <p>
                医疗数据信息可通过互联网、3G/4G物联网、无线传感网等网络进行安全传递、有效交互。
              </p>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="shadow">
              <img src="../../assets/Medical_Program_icon03.png" alt="">
              <h4>
                数据应用
              </h4>
              <p>
                云端服务将接受到的数据信息进行加工、处理、分析和统计，将其大数据化、业务化和可视化。
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="section_w " style="padding-bottom: 0px">
      <div class="container" style="position: relative;z-index: 10">
        <div class="section_title right">
          <p>
            体系化系统集成
          </p>
          <aside>
            Systematization
          </aside>
        </div>
      </div>
      <div class="Systematization">
        <div class="container Systematization_big">
          <div class="t1">
            <h5>设备接入平台</h5>
            <p>
              通过物联网卡&模组实现设备感知以及通信接入；集成移动、电信、联通多家运营商的运营实现流量以及通道管理。
            </p>
          </div>
          <div class="t2">
            <h5>数据传输平台</h5>
            <p>
              通过4G将采集的数据进行上传，并对设备试试故障诊断和固件升级等能力。
            </p>
          </div>
          <div class="t3">
            <h5>数据应用平台</h5>
            <p>
              通过自建或者公有云方式实现数据接入、分析诊断以及业务服务应用能力。
            </p>
          </div>
        </div>
        <div class="container Systematization_small">
          <div class="col-xs-12">
            <h5>设备接入平台</h5>
            <p>
              通过物联网卡&模组实现设备感知以及通信接入；集成移动、电信、联通多家运营商的运营实现流量以及通道管理。
            </p>
          </div>
          <div class="col-xs-12">
            <h5>数据传输平台</h5>
            <p>
              通过4G将采集的数据进行上传，并对设备试试故障诊断和固件升级等能力。
            </p>
          </div>
          <div class="col-xs-12">
            <h5>数据应用平台</h5>
            <p>
              通过自建或者公有云方式实现数据接入、分析诊断以及业务服务应用能力。
            </p>
          </div>
        </div>

      </div>
    </div>
    <div class="section_w application">
      <div class="container" style="position: relative;z-index: 10">
        <div class="section_title left">
          <p>
            整体应用结构
          </p>
          <aside>
            Overall application
          </aside>
        </div>
        <div class="row">
          <div class="col-xs-12">
            <img src="../../assets/Medical_application_pic.png" alt="" class="">
          </div>
        </div>
      </div>
    </div>
    <div class="section_w" style="padding-bottom: 0px">
      <div class="container" style="position: relative;z-index: 10">
        <div class="section_title right">
          <p>
            七大核心功能
          </p>
          <aside>
            CORE FEATURE
          </aside>
        </div>
      </div>
      <div class="Seven">
        <div class="container">
          <div class="row">
            <img src="../../assets/seven.png" alt="">
          </div>
        </div>
      </div>
    </div>
    <div class="section_w" style="padding-bottom: 0px">
      <div class="container" style="position: relative;z-index: 10">
        <div class="section_title left">
          <p>
            业务价值
          </p>
          <aside>
            Business  value
          </aside>
        </div>
      </div>
      <div class="Business">
        <div class="container">
          <div class="row Business_big">
            <img src="../../assets/value.png" alt="">
          </div>
          <div class="row Business_small">
            <div class="col-xs-12">
              <h5>It资产管理</h5>
              <p>
                医疗资产管理，定位设备，设备维护状态
              </p>
            </div>
            <div class="col-xs-12">
              <h5>运营监控</h5>
              <p>
                试剂的管理与数据管理技术
              </p>
            </div>
            <div class="col-xs-12">
              <h5>部门业务协同</h5>
              <p>
                销售维护和客服一致管理
              </p>
            </div>
            <div class="col-xs-12">
              <h5>物联网支持</h5>
              <p>
                远程控制和设备配置
              </p>
            </div>
            <div class="col-xs-12">
              <h5>管理支持</h5>
              <p>
                数据分析、经济效益分析，管理决策支持
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="section_w case">
      <div class="container">
        <div class="row">
          <div class="col-sm-4 ">
            <img src="../../assets/Medical_Case_pic01.jpg" alt="">
          </div>
          <div class="col-sm-4">
            <img src="../../assets/Medical_Case_pic02.jpg" alt="">
          </div>
          <div class="col-sm-4">
            <img src="../../assets/Medical_Case_pic03.jpg" alt="">
          </div>
          <div class="col-sm-4">
            <img src="../../assets/Medical_Case_pic04.jpg" alt="">
          </div>
          <div class="col-sm-4">
            <img src="../../assets/tms02.png" alt="">
          </div>
          <div class="col-sm-4">
            <img src="../../assets/tms03.png" alt="">
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>

  import Footer from '../../components/Footer'
  export default {
    name: 'Introduction',
    components: {
      Footer
    },
    props: {}
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .case img {
    width: 100%;
  }
  .case .row>div {
    margin-bottom: 30px;
  }
  .Business_small {
    text-align: center;
  }
  .Business_small p{
    font-size: 1.8rem;
    color: #666;
    margin-bottom: 30px;
  }
  .Business_small h5  {
    color: #fffffe;
    background: #fea521;
    padding: 10px 30px;
    display: inline-block;
    margin: 0px 0px 30px;
  }
  .case {
    background: url("../../assets/Medical_Case_bg.jpg") no-repeat center;
    background-size: 100% 100%;
  }
  .Business {
    background: url("../../assets/Medical_business_bg.jpg") no-repeat center;
    background-size: 100% 100%;
  }

  .Business img{
    width: 100%;
  }
  .Seven {
    background: url("../../assets/Medical_value_bg.jpg") no-repeat center;
    background-size: 100% 100%;
    padding: 40px 0px;
  }
  .Seven img{
    width: 100%;
  }
  .application {
    background: url("../../assets/Medical_application_bg.jpg") no-repeat center;
    background-size: 100% 100%;
  }
  .application img {
    width: 100%;
  }
  .Systematization h5 {
    color: #8c4c00;
    font-size: 2.8rem;
    margin: 0px 0px 40px;
    text-align: center;
    position: relative;
  }
  .Systematization h5:after {
    content: '';
    display: inline-block;
    width: 100px;
    background: #8c4c00;
    height: 1px;
    overflow: hidden;
    position: absolute;
    bottom: -10px;
    left: 50%;
    transform: translateX(-50%);

  }
  .Systematization p {
    color: #8c4c00;
    font-size: 1.8rem;
  }
  .Systematization {
    padding: 60px 0px;
    background: url("../../assets/Medical_systematization_Program_bg.jpg") no-repeat center;
    background-size: 100% 100%;
  }
  .Systematization_big {
    position: relative;
  }
  .Systematization_big > div {
    width: 19%;
    position: absolute;
  }
  .Systematization_big .t1 {
    left: 2%;
    bottom: 22%;
  }
  .Systematization_big .t2 {
    left: 40%;
    top: 2%;
  }
  .Systematization_big .t3 {
    right: 2%;
    bottom: 22%;
  }
  .Systematization_big {
    min-height: 400px;
    background: url("../../assets/Medical_systematization_Program_pic.png") no-repeat center bottom;
  }
  .banner img {
    width: 100%;

  }
  .equipment {
    background: url("../../assets/Medical_application_bg.jpg") no-repeat center;
    background-size: 100% 100%;
  }
  .equipment .shadow {
    text-align: center;
    padding: 30px 15px;
  }
  .equipment .shadow:hover {
    background: #fff;
    box-shadow: 0px 0px 20px #dde2e5;
  }
  .equipment .row h4{
    font-size: 2.8rem;
    color: #fe9902;
    text-align: center;
    margin: 40px 0px 20px;
  }
  .equipment .row p{
    color: #666;
    text-align: left;
    line-height: 28px;
    font-size:18px;
  }
  .Systematization_small {
    display: none;
  }
  @media (max-width: 991px) {

  }

  @media (min-width: 992px) {

  }

  @media (min-width: 769px) {
    .Business_small {
      display: none;
    }

  }

  @media (max-width: 768px) {
    .Systematization_small {
      display: block;
    }
    .Business_small {
      display: block;
    }
    .Systematization_big {
      display: none;
    }
    .Business_big {
      display: none;
    }
    .Systematization p {
      margin-bottom: 30px;
    }

  }
</style>
